export default {"src":"/_next/static/media/north-korea.dc783629.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};